import { DashboardParamsProviders } from "@/context/DashboardParamsProviders";
import { Outlet, useLocation } from "react-router";

const EditForms = () => {
  const entity = useLocation().pathname.split("/")[2];

  return entity ? (
    <DashboardParamsProviders
      persistInSearchParams={false}
      key={entity}
      storageKey={entity}
    >
      <Outlet />
    </DashboardParamsProviders>
  ) : (
    <Outlet />
  );
};

export default EditForms;
